/** Klasa na `<html>` — stabilny landing bez Lenis / canvas / ciężkich efektów GPU. */
export const GECKO_COMPAT_CLASS = 'gecko-compat';

/**
 * Firefox, LibreWolf i pochodne (Gecko bez Chromium).
 * W LibreWolf RFP + canvas często psują Lenis, backdrop-filter i animacje scroll.
 */
export function isGeckoBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/firefox|librewolf|icecat|floorp|waterfox/i.test(ua)) return true;
  if (typeof window !== 'undefined' && 'InstallTrigger' in window) return true;
  return typeof (document as Document & { documentMode?: unknown }).documentMode === 'undefined'
    && /Gecko\//i.test(ua)
    && !/Chrome|Chromium|Edg|OPR|Safari/i.test(ua);
}

export function shouldUseLandingLenis(): boolean {
  if (typeof window === 'undefined') return false;
  if (isGeckoBrowser()) return false;
  return window.matchMedia('(min-width: 769px)').matches;
}

export function applyGeckoCompatClass(): void {
  if (typeof document === 'undefined') return;
  if (isGeckoBrowser()) {
    document.documentElement.classList.add(GECKO_COMPAT_CLASS);
  }
}

/** iPhone / iPad — WebKit; CSS marquee z custom properties bywa niestabilny. */
export function isIosWebKit(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

/** Safari (iOS, iPadOS, macOS) — % w transform i maski na krawędziach bywają zawodne. */
export function isWebKitBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  if (isIosWebKit()) return true;
  const ua = navigator.userAgent;
  if (/Chrome|Chromium|Edg|OPR|Firefox/i.test(ua)) return false;
  return /Safari/i.test(ua) && /Apple/i.test(navigator.vendor || '');
}
